import axios from "axios";
const BASE_URL = window.location.origin + "/api";
// const BASE_URL = "https://app.clearrmynotice.com/api";

const token = localStorage.getItem("jwtToken");
const resetToken = localStorage.getItem("resetToken");
export const axiosWithoutHeader = axios.create({
    baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        
    },
    withCredentials: true,
});

export const axiosReset = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${resetToken}`,
    },
    withCredentials: true,
});

export const axiosQuick = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});
